"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.NavActions = void 0;
var NavActions;
exports.NavActions = NavActions;

(function (NavActions) {
  NavActions["expandNav"] = "NAV_EXPAND";
  NavActions["collapseNav"] = "NAV_COLLAPSE";
})(NavActions || (exports.NavActions = NavActions = {}));